import { ROUTER_NAMES } from '../routerNamesConfig';

export const MACHINES_CARD_CONFIG = {
	path: 'technic/:cardId',
	name: ROUTER_NAMES.MACHINES.CARD,
	component: () => import('@/views/company/cards/technic/CompanyCardTechnicView.vue'),
	children: [
		{
			path: '',
			name: ROUTER_NAMES.MACHINES.CARD_TABS.GENERAL,
			component: () => import('@/views/company/cards/technic/tabs/CompanyCardTechnicGeneralTabView.vue'),
		},
		{
			path: 'devices-and-sensors',
			name: ROUTER_NAMES.MACHINES.CARD_TABS.DEVICES_AND_SENSORS,
			component: () => import('@/views/company/cards/technic/tabs/CompanyCardTechnicDevicesAndSensorsTabView.vue'),
		},
		{
			path: 'events',
			name: ROUTER_NAMES.MACHINES.CARD_TABS.EVENTS,
			component: () => import('@/views/company/cards/technic/tabs/CompanyCardTechnicEventsTabView.vue'),
		},
		{
			path: 'orders-and-work',
			name: ROUTER_NAMES.MACHINES.CARD_TABS.ORDERS_AND_WORK,
			component: () => import('@/views/company/cards/technic/tabs/CompanyCardTechnicOrdersAndWorkTabView.vue'),
		},
		{
			path: 'incidents',
			name: ROUTER_NAMES.MACHINES.CARD_TABS.INCIDENTS,
			component: () => import('@/views/company/cards/technic/tabs/CompanyCardTechnicIncidentsTabView.vue'),
		},
		{
			path: 'resources',
			name: ROUTER_NAMES.MACHINES.CARD_TABS.RESOURCES,
			component: () => import('@/views/company/cards/technic/tabs/CompanyCardTechnicResourcesTabView.vue'),
		},
		{
			path: 'service-book',
			name: ROUTER_NAMES.MACHINES.CARD_TABS.SERVICE_BOOK,
			component: () => import('@/views/company/cards/technic/tabs/CompanyCardTechnicServiceBookTabView.vue'),
		},
		{
			path: 'documents',
			name: ROUTER_NAMES.MACHINES.CARD_TABS.DOCUMENTS,
			component: () => import('@/views/company/cards/technic/tabs/CompanyCardTechnicDocumentsTabView.vue'),
		},
	]
}
